module.exports = __webpack_public_path__ + "fonts/DrukCondensed-Super-Web.d266867.woff2";